<template>
  <div v-if="qrCode" class="layer paymentLayer notranslate">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="closeQr"><span class="blind">close</span></button>
      <div v-if="timer > 0">
        <p class="layerTitle">{{locale.qr_title}}</p>
        <div class="countDown">
          {{locale.qr_time}}
          <p>{{remainTimer}}</p>
        </div>
        <vue-qrcode
          :value="qrCode"
          :scale="6" />
      </div>
      <div v-else>
        <p class="layerTitle">{{locale.qr_timeover_1}}<br>{{locale.qr_timeover_2}}</p>
        <div class="btns">
          <button type="button" class="btn btnFull" @click.stop="closeQr">{{locale.cancel}}</button>
        </div>
      </div>
      <div v-if="wsMessage.length">
        <p v-for="(message, index) in wsMessage" :key="index">{{message}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  name: 'PaymentQrCode',
  props: [
    'lang',
    'locale',
    'qrCode'
  ],
  components: {
    VueQrcode
  },
  computed: {
    moid () {
      return this.$store.getters['payment/getPaymentInfo'].Moid
    },
    remainTimer () {
      const seconds = this.timer
      const date = new Date(seconds * 1000).toISOString().substr(14, 5)
      return date
    }
  },
  mounted () {
    this.countDown()
    this.wsConnect()
  },
  data () {
    return {
      timer: 300,
      wsStatus: 'ready',
      wsMessage: []
    }
  },
  methods: {
    wsConnect () {
      if (this.socket === undefined || this.socket.readyState === 3) {
        this.socket = new WebSocket(process.env.VUE_APP_WEBSOCKET)
        this.socket.onopen = (e) => {
          this.onOpen(e)
        }
        this.socket.onclose = (e) => {
          this.onClose(e)
        }
        this.socket.onmessage = (e) => {
          this.onMessage(e)
        }
        this.socket.onerror = (e) => {
          this.onError(e)
        }
      }
    },
    wsDisconnect () {
      if (this.socket.readyState === 1) {
        this.wsStatus = 'close'
        this.socket.close()
      }
    },
    onOpen (e) {
      const rid = this.moid
      const data = {
        action: 'sendmessage',
        data: {
          cmd: 'payment',
          rid: rid
        }
      }
      this.wsStatus = 'start'
      this.sendData(JSON.stringify(data))
    },
    sendData (data) {
      this.wsStatus = 'send'
      this.socket.send(data)
    },
    onClose () {
      this.socket.close()
    },
    onMessage (e) {
      const res = JSON.parse(e.data)
      this.wsStatus = 'message'
      if (res.orderReason === 'paid') {
        const resParams = res
        this.wsStatus = 'success'
        this.onClose()
        delete resParams.cmd
        this.wsComplete(resParams)
      } else {
        this.wsStatus = 'fail'
      }
    },
    onError (e) {
      this.wsStatus = 'error'
    },
    wsComplete (data) {
      const params = new URLSearchParams(data).toString()
      const searches = new URLSearchParams(window.location.search)
      searches.delete('frame')
      setTimeout(() => {
        // alert(this.locale.complete_request)
        // this.$router.push({ name: 'complete', params: { lang: this.lang } })
        window.location = `${window.location.origin}${window.location.pathname}?${searches}&${params}#/${this.lang}/complete`
      }, 1000)
    },
    countDown () {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer -= 1
          this.countDown()
        }, 1000)
      }
    },
    closeQr () {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentLayer {
  .inner {
    padding: 45px 30px;
    border-radius: 8px;
    text-align: center;
  }
  .countDown {
    margin-top: 1.5em;
    margin-bottom: 1em;
    font-size: 1.1em;
    line-height: 1.1;
    p {
      font-size: 3em;
      font-weight: bold;
      font-family: 'serif';
    }
  }
  .btns {
    margin-top: 30px;
    .btn {
      padding-top: 1em;
      padding-bottom: 1em;
      border-radius: 8px;
    }
  }
}
</style>
